/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImportMetaDataResponse } from '../../models/import-meta-data-response';

export interface ImportMasterData$Params {
}

export function importMasterData(http: HttpClient, rootUrl: string, params?: ImportMasterData$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportMetaDataResponse>> {
  const rb = new RequestBuilder(rootUrl, importMasterData.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImportMetaDataResponse>;
    })
  );
}

importMasterData.PATH = '/api/MetaModel/masterData/import';
